import { useCallback } from 'react';
import useDefaultProperties from 'campaigns-lib/hooks/useDefaultProperties';
import useGetCampaignCreatedTrackingProps from 'campaigns-lib/hooks/useGetCampaignCreatedTrackingProps';
import useGetContextualAlertConfig from '../../hooks/useGetContextualAlertConfig';
import { UsageTracker } from 'campaigns-lib/utils/usageTracker';
import { getUnformattedCampaignLegacy } from 'campaigns-lib/data/CampaignDao';
import AsyncObjectBuilderClient from './AsyncObjectBuilderClient';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CustomCampaignEditPanel({
  onClose,
  use,
  campaign,
  appName,
  screen = 'campaign-select',
  supportedAssets = [],
  associatedUnsupportedAssets = [],
  objectBuilderUiProps,
  assetObjectType
}) {
  const contextualAlertConfig = useGetContextualAlertConfig(campaign ? campaign.guid : undefined, campaign ? campaign.objectId : undefined, use, supportedAssets, associatedUnsupportedAssets);
  const {
    data: defaultProperties,
    loading,
    error
  } = useDefaultProperties({
    campaign
  });
  const getCampaignCreatedTrackingProps = useGetCampaignCreatedTrackingProps();
  const handleClose = useCallback(args => {
    const {
      createdObject,
      updatedObject
    } = args || {};
    if (createdObject) {
      const additionalProperties = getCampaignCreatedTrackingProps(createdObject);
      UsageTracker.track('campaignsCreate', Object.assign({
        action: 'campaign created',
        applicationId: appName,
        screen
      }, assetObjectType && {
        assetType: assetObjectType
      }, additionalProperties));
    } else if (updatedObject && updatedObject.state === 'ENQUEUED') {
      getUnformattedCampaignLegacy(updatedObject.campaignId).then(campaignResponse => {
        const additionalProperties = getCampaignCreatedTrackingProps(campaignResponse);
        UsageTracker.track('campaignsCreate', Object.assign({
          action: 'campaign cloned',
          applicationId: appName,
          screen
        }, assetObjectType && {
          assetType: assetObjectType
        }, additionalProperties));
      }).catch(() => {});
    }
    onClose(args);
  }, [appName, assetObjectType, getCampaignCreatedTrackingProps, onClose, screen]);
  if (use !== 'create' && (!defaultProperties || loading || error)) {
    return null;
  }
  return /*#__PURE__*/_jsx(AsyncObjectBuilderClient, Object.assign({
    appName: appName,
    objectTypeId: "0-35",
    panelType: use,
    objectId: use !== 'create' && campaign ? campaign.guid : '',
    onClose: handleClose,
    shouldRenderCreateAndAddButton: false,
    defaultProperties: defaultProperties,
    contextualAlertConfig: contextualAlertConfig
  }, objectBuilderUiProps || {}));
}